import React, { useEffect, useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import styles from "../../styles/shap_of_you.module.scss";
import img1 from "../../assets/images/WalkthroughScreen.png";
import img21 from "../../assets/images/WalkthroughScreen2n.png";
import img3 from "../../assets/images/WalkthroughScreen3.png";
import { DesktopNavigationProps } from "./types";

const WalkthroughScreen: React.FC<DesktopNavigationProps> = ({
  navigateToStep,
  isAuthenticated,
  logStep,
}) => {
  const [loading, setLoading] = useState(false);

  // Log intro slider viewed on mount
  useEffect(() => {
    if (logStep) {
      logStep("intro_slider_viewed");
    }
  }, [logStep]);

  // Handle "Get Started" button click with consent checking (same as mobile)
  const handleGetStarted = async () => {
    setLoading(true);

    try {
      if (isAuthenticated) {
        // User is authenticated - check consent status via API
        const { data } = await httpClient.get(endpoints.auth.getConsentForm());

        if (data.statusText === "accepted") {
          // Scenario 1: Consent already accepted - skip TC, go to welcome
          console.log("Consent already accepted, skipping TC screen");
          navigateToStep("welcome");
        } else {
          // Scenario 2: Consent rejected - show TC screen
          navigateToStep("tc");
        }
      } else {
        // Scenario 3: User is NOT authenticated - go to TC without API call
        navigateToStep("tc");
      }
    } catch (error) {
      console.error("Error checking consent status:", error);
      // If API fails, show TC screen anyway
      navigateToStep("tc");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-none d-md-block w-100">
      <div className={styles.wrapper_slider_desktop}>
        <Swiper
          spaceBetween={0}
          navigation={false}
          // pagination={{
          //   clickable: false,
          // }}
          autoplay={{
            delay: 3000, // ✅ 10 seconds
            disableOnInteraction: false,
          }}
          modules={[Navigation, Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className={styles.swiperSlide}>
              <div className={styles.slide}>
                <Image
                  className={styles.bgImage}
                  src={img1}
                  alt="Scan Your Face"
                />
                <div className={styles.overlay_n}>
                  <h2>Scan Your Face</h2>
                  <p>Upload or take a photo of your face</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.swiperSlide}>
              <div className={styles.slide}>
                <Image
                  className={styles.bgImage}
                  src={img21}
                  alt="Live Analysis"
                />
                <div className={styles.overlay_n}>
                  <h2>Live Analysis</h2>
                  <p>Get instant analysis of your face type</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className={styles.swiperSlide}>
              <div className={styles.banner1}>
                <Image className={styles.bgImage} src={img3} alt="" />
                <div className={styles.overlay_n}>
                  <aside className="w-100">
                  <h2>The Shape of You</h2>
                  <p>
                    Discover your face shape and shop jewellery made for you.
                  </p>
                  <div className={styles.buttonGroup}>
                    <div className={styles.btn_conta}>
                      <button
                        className={styles.secondaryBtn}
                        onClick={() => navigateToStep("about")}
                      >
                        <span>Know More</span>
                      </button>

                      <button
                        className={styles.primaryBtn}
                        onClick={handleGetStarted}
                        disabled={loading}
                        style={
                          loading
                            ? {
                                background: "#d3d3d3",
                                color: "#888",
                                cursor: "not-allowed",
                                opacity: 0.6,
                              }
                            : {}
                        }
                      >
                        {loading ? "Loading..." : "Get Started"}{" "}
                        {!loading && (
                          <svg
                            width="25"
                            height="17"
                            viewBox="0 0 30 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0.000209928 11.0458L0 8.04596H24.2579L18.3333 2.12131L20.4546 0L30.0006 9.54596L20.4546 19.092L18.3333 16.9705L24.258 11.046L0.000209928 11.0458Z"
                              fill="white"
                            />
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>
                  </aside>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default WalkthroughScreen;
